export function getSchoolIcon(): string {
  return `
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" fill="currentColor" clip-rule="evenodd" d="M1 1.77539V13.7754C4.42857 14.4004 7 15.7754 7 15.7754V3.77539C7 3.77539 4.42857 2.27539 1 1.77539ZM15 1.77539V13.7754C11.5714 14.4004 9 15.7754 9 15.7754V3.77539C9 3.77539 11.5714 2.27539 15 1.77539Z" />
  </svg>
  `;
}
